import React, { Fragment } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { Link } from 'react-router-dom';
import '../../assets/css/scss/component/_footerLink.scss';
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { FOOTER_MENU } from '../../constant/menuAndProfile';

export default function FooterLink() {
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    return (
        <Fragment>
            <ListGroup as="ul" className="list-unstyled bottom-links mb-0 d-block text-center text-sm-left d-sm-flex align-items-center justify-content-center">
                <ListGroup.Item as="li">
                    <Link to="/terms" title="Terms of Use">{FOOTER_MENU[selectedLanguage]['terms_of_use']}</Link>
                </ListGroup.Item>
                <ListGroup.Item as="li">
                    <Link to="/privacypolicy" title="Privacy and Policy">{FOOTER_MENU[selectedLanguage]['privacy_and_policy']}</Link>
                </ListGroup.Item>
                {/* <ListGroup.Item as="li">
                    <Link to="/" title="Feedback">Feedback</Link>
                </ListGroup.Item> */}
                <ListGroup.Item as="li">
                    <Link to="/aboutus" title="About Us">{FOOTER_MENU[selectedLanguage]['about_us']}</Link>
                </ListGroup.Item>
            </ListGroup>
            <p className="text-center mt-3 mb-0">{FOOTER_MENU[selectedLanguage]['all_rights_reserved']}</p>
        </Fragment>
    )
}
